import React from 'react'
import Logo from '../../assets/logo.png'
import { Link } from 'react-router-dom';
import { FaFacebook, FaGoogle, FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <>
      <div className="bg-richblue-900">
        <div className="flex lg:flex-row gap-8 items-center justify-between w-11/12 max-w-maxContent text-richblue-200 leading-6 mx-auto relative py-14">
          <div className="border-b w-[100%] flex flex-col lg:flex-row pb-5 border-richblue-700">
            {/* Section 1 */}
            <div className="lg:w-[50%] flex flex-wrap flex-row justify-between lg:border-r lg:border-richblue-700 pl-3 lg:pr-5 gap-3">
              <div className="w-[30%] flex flex-col gap-3 lg:w-[30%] mb-7 lg:pl-0 ">
                <img
                  src={Logo}
                  alt=""
                  className="object-contain relative right-4"
                />
                <h1 className="text-richblue-50 font-semibold text-[16px]">
                  Company
                </h1>
                <div className="flex flex-col gap-2">
                  {["About", "Contact Us"].map((ele, i) => {
                    return (
                      <div
                        key={i}
                        className="text-[14px] cursor-pointer hover:text-richblue-50 transition-all duration-200"
                      >
                        <Link to={ele.toLowerCase()}>{ele}</Link>
                      </div>
                    );
                  })}
                </div>
                <div className="flex gap-3 text-lg">
                <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-richblue-50">
                    <FaFacebook size={20} />
                  </a>
                  <a href="https://www.linkedin.com/in/mavens-techsolutions-4a0114354/" target="_blank" rel="noopener noreferrer" className="hover:text-richblue-50">
                    <FaLinkedin size={20} />
                  </a>
                  <a href="https://www.instagram.com/mavenstechsolutions" target="_blank" rel="noopener noreferrer" className="hover:text-richblue-50">
                    <FaInstagram size={20} />
                  </a>
                  <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-richblue-50">
                    <FaTwitter size={20} />
                  </a>
                  <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-richblue-50">
                    <FaYoutube size={20} />
                  </a>
                  
                </div>
                <div></div>
              </div>

              <div className="w-[48%] lg:w-[30%] mb-7 lg:pl-0">
                <h1 className="text-richblue-50 font-semibold text-[16px]">
                  Resources
                </h1>
                <div className="flex flex-col gap-2 mt-2">
                  {["Blog", "Articles", "Docs", "Projects", "Videos"].map(
                    (ele, index) => {
                      return (
                        <div
                          key={index}
                          className="text-[14px] cursor-pointer hover:text-richblue-50 transition-all duration-200"
                        >
                          <Link to={ele.split(" ").join("-").toLowerCase()}>
                            {ele}
                          </Link>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
              <div className="w-[48%] lg:w-[30%] mb-7 lg:pl-0">
                <h1 className="text-richblue-50 font-semibold text-[16px]">
                  Plans
                </h1>

                <div className="flex flex-col gap-2 mt-2">
                  {["Book a Demo", "Paid Membership", "Buy a Course"].map(
                    (ele, index) => {
                      return (
                        <div
                          key={index}
                          className="text-[14px] cursor-pointer hover:text-richblue-50 transition-all duration-200"
                        >
                          <Link to={ele.split(" ").join("-").toLowerCase()}>
                            {ele}
                          </Link>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </div>

            {/* Section 2 */}
            <div className="lg:w-[50%] flex flex-wrap flex-row justify-between pl-3 lg:pl-5 gap-3">
              <div className="w-[48%] lg:w-[30%] mb-7 lg:pl-0">
                <h1 className="text-richblue-50 font-semibold text-[16px]">
                  Courses
                </h1>
                <div className="flex flex-col gap-2 mt-2">
                  {[
                    "ITIL 4 Foundation",
                    "SIAM Foundation",
                    "DevOps Foundation",
                    "SRE Foundation",
                  ].map((ele, index) => {
                    return (
                      <div
                        key={index}
                        className="text-[14px] cursor-pointer hover:text-richblue-50 transition-all duration-200"
                      >
                        <Link to={"/courses/"+ele.split(" ").join("-").toLowerCase()}>
                          {ele}
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="w-[48%] lg:w-[30%] mb-7 lg:pl-0">
                <h1 className="text-richblue-50 font-semibold text-[16px] pb-5"></h1>

                <div className="flex flex-col gap-2 mt-2">
                  {[
                    "PMP Training",
                    "PRINCE2® Foundation",
                    "AWS Solution Architect Associates",
                  ].map((ele, index) => {
                    return (
                      <div
                        key={index}
                        className="text-[14px] cursor-pointer hover:text-richblue-50 transition-all duration-200"
                      >
                        <Link to={"/courses/"+ele.split(" ").join("-").toLowerCase()}>
                          {ele}
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="w-[48%] lg:w-[30%] mb-7 lg:pl-0">
                <div className="text-richblue-50 font-semibold text-[16px] pb-5 "></div>

                <div className="flex flex-col gap-2 mt-2">
                  {[
                    "Microsoft Azure Architect 304",
                    "GenAI In Project Management",
                    "Prompt Engineering",
                  ].map((ele, index) => {
                    return (
                      <div
                        key={index}
                        className="text-[14px] cursor-pointer hover:text-richblue-50 transition-all duration-200"
                      >
                        <Link to={"/courses/"+ele.split(" ").join("-").toLowerCase()}>
                          {ele}
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-row items-center justify-between w-11/12 max-w-maxContent text-richblue-200 mx-auto  pb-14 text-sm">
          {/* Section 1 */}

          <div className="flex justify-between lg:items-start items-center flex-col lg:flex-row gap-3 w-full">
            <div className="flex flex-row">
              {["Privacy Policy", "Cookie Policy", "Terms"].map((ele, i) => {
                return (
                  <div
                    key={i}
                    className={` ${
                      3 - 1 === i
                        ? ""
                        : "border-r border-richblue-700 cursor-pointer hover:text-richblue-50 transition-all duration-200"
                    } px-3 `}
                  >
                    <Link to={ele.split(" ").join("-").toLocaleLowerCase()}>
                      {ele}
                    </Link>
                  </div>
                );
              })}
            </div>

            <div className="text-center">
              Copyright © 2025 All Rights Reserved{" "} | Mavens TechSolutions Pvt. Ltd.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer